import { createSlice } from '@reduxjs/toolkit';
import {
  deleteJournalTemplate,
  getJournalTemplateByID,
  getJournalTemplates,
  saveJournalTemplate,
} from './journalTemplatesActions';

const initialState = {
  listLoading: false,
  journalTemplates: [],
  activeJournal: null,
  journalLoading: null,
  error: null,
  success: false,
};

const journalTemplatesSlice = createSlice({
  name: 'journals',
  initialState,
  reducers: {
    setActiveJournal: (state, { payload }) => {
      state.activeJournal = payload;
    },
  },
  extraReducers: {
    // get journal templates
    [getJournalTemplates.pending]: state => {
      state.listLoading = true;
    },
    [getJournalTemplates.fulfilled]: (state, { payload }) => {
      state.listLoading = false;
      state.journalTemplates = payload.data;
    },
    [getJournalTemplates.rejected]: (state, { payload }) => {
      state.listLoading = false;
      state.error = payload;
    },

    // get journal template by id
    [getJournalTemplateByID.pending]: state => {
      state.journalLoading = true;
    },
    [getJournalTemplateByID.fulfilled]: (state, { payload }) => {
      state.journalLoading = false;
      state.activeJournal = payload.data;
    },
    [getJournalTemplateByID.rejected]: (state, { payload }) => {
      state.journalLoading = false;
      state.error = payload;
    },

    // save journal
    [saveJournalTemplate.pending]: state => {
      state.journalLoading = true;
    },
    [saveJournalTemplate.fulfilled]: (state, { payload }) => {
      state.journalLoading = false;
      state.activeJournal = payload.data;
      state.journalTemplates = payload.status===200? state.journalTemplates.map(template=>{
        if(template.id === payload.data.id) {
          return payload.data
        }
        return template
      }) : [...state.journalTemplates, payload.data];
    },
    [saveJournalTemplate.rejected]: (state, { payload }) => {
      state.journalLoading = false;
      state.error = payload;
    },
    // delete journal
    [deleteJournalTemplate.pending]: state => {
      // state.listLoading = true;
    },
    [deleteJournalTemplate.fulfilled]: (state, { payload }) => {
      state.listLoading = false;
    },
    [deleteJournalTemplate.rejected]: (state, { payload }) => {
      state.listLoading = false;
      state.error = payload;
    },
  },
});

export const { setActiveJournal } = journalTemplatesSlice.actions;
export default journalTemplatesSlice.reducer;
